import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { fetchAuthSession } from "aws-amplify/auth";
const parseJwt = async () => {
  try {
    const session = await fetchAuthSession();
    return JSON.stringify(session);
  } catch (error) {
    console.error(error);
  }
};

function AuthVerify() {
  const location = useLocation();
  useEffect(() => {
    const handleLocationChange = async () => {
      try {
        await parseJwt().then();
      } catch (e) {
        window.location.reload();
      }
    };

    handleLocationChange();
  }, [location]);

  return <div></div>;
}

export default AuthVerify;
